import { jsx as c, jsxs as h } from "react/jsx-runtime";
import { useFormik as P } from "formik";
import { useEffect as w, useMemo as S, useState as k, useRef as C } from "react";
import { AvatarList as x } from "../../../atoms/AvatarList/AvatarList.es.js";
import { Input as K } from "../../../atoms/Input/Input.container.es.js";
import { forwardRef as I, useMultiStyleConfig as M, useOutsideClick as T, chakra as p } from "@chakra-ui/react";
import { SavedListItemSkeleton as $ } from "./SavedListItemSkeleton.es.js";
var R = function() {
};
function B(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  e && e.addEventListener && e.addEventListener.apply(e, t);
}
function H(e) {
  for (var t = [], r = 1; r < arguments.length; r++)
    t[r - 1] = arguments[r];
  e && e.removeEventListener && e.removeEventListener.apply(e, t);
}
var N = typeof window < "u", O = N ? window : null, y = function(e) {
  return !!e.addEventListener;
}, L = function(e) {
  return !!e.on;
}, z = function(e, t, r, n) {
  r === void 0 && (r = O), w(function() {
    if (t && r)
      return y(r) ? B(r, e, t, n) : L(r) && r.on(e, t, n), function() {
        y(r) ? H(r, e, t, n) : L(r) && r.off(e, t, n);
      };
  }, [e, t, r, JSON.stringify(n)]);
};
const A = z;
var F = function(e) {
  return typeof e == "function" ? e : typeof e == "string" ? function(t) {
    return t.key === e;
  } : e ? function() {
    return !0;
  } : function() {
    return !1;
  };
}, J = function(e, t, r, n) {
  t === void 0 && (t = R), r === void 0 && (r = {}), n === void 0 && (n = [e]);
  var i = r.event, m = i === void 0 ? "keydown" : i, s = r.target, v = r.options, f = S(function() {
    var l = F(e), d = function(u) {
      if (l(u))
        return t(u);
    };
    return d;
  }, n);
  A(m, f, s, v);
};
const g = J;
var V = function(e) {
  var t = k([!1, null]), r = t[0], n = t[1];
  return g(e, function(i) {
    return n([!0, i]);
  }, { event: "keydown" }, [r]), g(e, function(i) {
    return n([!1, i]);
  }, { event: "keyup" }, [r]), r;
};
const b = V, q = (e) => {
  let t = {};
  return e.name || (t.name = "Please enter a name"), t;
}, Z = I((e, t) => {
  const r = C(null), {
    firstFourCreator: n = [],
    isSubmitting: i = !1,
    name: m = "",
    onCancel: s,
    onSubmit: v,
    ...f
  } = e, l = M("SavedListItem", {
    variant: "center"
  }), d = S(
    () => n.map(({ avatar: a, name: E }) => ({ src: a, alt: E })),
    [n]
  ), [u] = b((a) => a.key === "Escape"), o = P({
    initialValues: { name: m },
    onSubmit: v,
    validate: q
  });
  return w(() => {
    u && s && s();
  }, [u]), T({
    handler: (a) => {
      a.target instanceof HTMLElement && a.target.dataset.ignore === "click-outside" || (o.dirty && o.submitForm(), s && s());
    },
    ref: r
  }), i ? /* @__PURE__ */ c($, { ...f }) : /* @__PURE__ */ c(p.div, { ref: r, children: /* @__PURE__ */ h(
    p.div,
    {
      __css: l.root,
      "data-testid": "saved-list-create-item",
      as: "form",
      "data-group": !0,
      ref: t,
      onSubmit: o.handleSubmit,
      ...f,
      children: [
        /* @__PURE__ */ c(x, { size: "sm", avatars: d }),
        /* @__PURE__ */ c(
          K,
          {
            ...o.getFieldProps("name"),
            autoFocus: !0,
            disableFormik: !0,
            error: o.errors.name,
            flex: 1,
            info: `${o.values.name.length}/40 characters`,
            maxLength: 40,
            placeholder: "New list name",
            withClearButton: !1
          }
        )
      ]
    }
  ) });
});
export {
  Z as SavedListCreateItem
};
//# sourceMappingURL=SavedListCreateItem.es.js.map
